{
  "version": 1,
  "asset_id": "620b3c63-e8d8-4581-8f86-d36d5a422ae7",
  "project_id": "42f7b672-abb9-48a4-a474-c45868224dff",
  "url": "/Logo.png",
  "original_filename": "Logo.png",
  "content_type": "image/png",
  "alt": "Share The Med Logo"
}
